import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M16.504 2.25H7.5A5.25 5.25 0 0 0 2.25 7.5v9.004a5.246 5.246 0 0 0 5.246 5.246h5.43-.776v-8.1H11.1a.75.75 0 0 1 0-1.5h1.05v-1.095a3.405 3.405 0 0 1 3.405-3.405h.945a.75.75 0 0 1 0 1.5h-.945a1.905 1.905 0 0 0-1.905 1.905v1.095h2.85a.75.75 0 0 1 0 1.5h-2.85v8.1h-.724 3.578a5.246 5.246 0 0 0 5.246-5.245V7.496a5.246 5.246 0 0 0-5.246-5.246" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }